<template>
    <div>

        <h3>Configurações Gerais</h3>
        <div class="row form-group">
            <div class="col-md-6">
                <label for="">Dia Fechamento Inicial</label>
                <input class="form-control" type="number" v-model="day_start_period">
            </div>
            <div class="col-md-6">
                <label for="">Dia Fechamento Final</label>
                <input class="form-control" type="number" v-model="day_end_period">
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-6">
                <label for="">Minutos de Tolerância Antes</label>
                <input class="form-control" type="number" v-model="tolerance_minutes_before">
            </div>
            <div class="col-md-6">
                <label for="">Minutos de Tolerância Depois</label>
                <input class="form-control" type="number" v-model="tolerance_minutes_after">
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-4">
                <label for="">Integração com InnovSign?
                    <input type="checkbox" v-model="has_signature">
                </label>                
            </div>        
        </div>
        <div class="row">
            <div class="col-md-12">
                <button class="btn btn-primary mt-2" @click="salvar">Salvar</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){ 
        return {
            tolerance_minutes_before: 0,
            tolerance_minutes_after: 0,
            day_start_period: 0,
            day_end_period: 0,
            has_signature: false,
            id: 0,
        }
    },
    methods: {
        salvar(){
            
            let api = this.$store.getters.api + 'configurations'
            let self = this 

            if(this.id == 0){

                self.$http.post(api, {
                    tolerance_minutes_before: self.tolerance_minutes_before,
                    tolerance_minutes_after: self.tolerance_minutes_after,
                    day_start_period: self.day_start_period,
                    day_end_period: self.day_end_period
                }).then( response => {
                    
                    self.$message(
                        "Sucesso",
                        `Departamento cadastrado com sucesso`,
                        "success"
                    );
                }).catch( error => {
                    self.$message(null, error.response.data, "error");
                })
            } else {
                self.$http.put(api + '/' + self.id, {
                    tolerance_minutes_before: self.tolerance_minutes_before,
                    tolerance_minutes_after: self.tolerance_minutes_after,
                    day_start_period: self.day_start_period,
                    day_end_period: self.day_end_period
                }).then( response => {
                    
                    self.$message(
                        "Sucesso",
                        `Departamento cadastrado com sucesso`,
                        "success"
                    );
                }).catch( error => {
                    self.$message(null, error.response.data, "error");
                })
            }
        }
    
    },
    mounted(){

        let api = this.$store.getters.api + 'configurations'
        let self = this

        self.$http.get(api)
        .then(response => {

            var data = response.data.data

            if(data.length > 0){
                self.id = data[0].id;
                self.tolerance_minutes_before = data[0].tolerance_minutes_before
                self.tolerance_minutes_after = data[0].tolerance_minutes_after
                self.day_start_period = data[0].day_start_period
                self.day_end_period = data[0].day_end_period
            }

        })

    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Configuration/Configuration.vue